// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterItem_link__gUbFN","subLink":"FooterItem_subLink__jkS29"};